document.addEventListener('DOMContentLoaded', function() {
    let productSwiper = null;
    const initialWidthPx = 8;

    const initSwiper = () => {
        if (window.innerWidth <= 991 && !productSwiper) {
            productSwiper = new Swiper('.product-swiper', {
                direction: 'horizontal',
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                observer: true,
                observeParents: true,
                on: {
                    init: function() {

                        const realSlides = Array.from(this.slides).filter(slide => 
                            !slide.classList.contains('swiper-slide-duplicate')
                        );
                        this.totalSlides = realSlides.length;
                        

                        const widthContainer = document.querySelector('.new-product__scrollbar-track');
                        if (widthContainer) {
                            const initialWidth = (1 / this.totalSlides) * 100;
                            widthContainer.style.width = `${initialWidth}%`;
                        }
                    },
                    slideChange: function () {
                        const realSlides = Array.from(this.slides).filter(slide => 
                            !slide.classList.contains('swiper-slide-duplicate')
                        );
                        this.totalSlides = realSlides.length;
                        
                        const currentIndex = this.realIndex;
                        const widthPercentage = ((currentIndex + 1) / this.totalSlides) * 100;
                        const widthContainer = document.querySelector('.new-product__scrollbar-track');
                        if (widthContainer) {
                            widthContainer.style.width = `${widthPercentage}%`;
                        }
                    }
                }
            });
        } else if (window.innerWidth > 991 && productSwiper) {
            productSwiper.destroy(true, true);
            productSwiper = null;
        }
    };

    initSwiper();
    
    window.addEventListener('resize', initSwiper);

    const mediaContainer = document.querySelector('.new-product__media');
    const customScrollbar = document.querySelector('.new-product__custom-scrollbar');
    const widthContainer = document.querySelector('.new-product__scrollbar-track');
    if (!mediaContainer) return;

    let ticking = false;
    
    const initialHeightPx = 8;
    customScrollbar.style.height = `${initialHeightPx}%`;
    if (widthContainer) {
        widthContainer.style.width = '25%'; 
    }
    const calculateScrollPercentage = () => {
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight - windowHeight;
        const scrolled = window.pageYOffset;
        return (scrolled / documentHeight);
    };

    const updateScroll = () => {
        const scrollPercentage = calculateScrollPercentage() * 45;
        const maxScroll = mediaContainer.scrollHeight - mediaContainer.clientHeight;
        mediaContainer.scrollTop = maxScroll * scrollPercentage;
        customScrollbar.style.height = `${scrollPercentage * initialHeightPx}%`;
        ticking = false;
    };

    window.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                updateScroll();
                ticking = false;
            });
            ticking = true;
        }
    });
});

document.addEventListener('DOMContentLoaded', () => {

  
    const triggerElement = document.querySelector('.product-form__input--dropdown');
    

    if (triggerElement) {
  
  

      const targetNode = document.querySelector('.new-product__media');
      const scrollbarWrapper = document.querySelector('.new-product__scrollbar-wrapper');

      const callback = function(mutationsList, observer) {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
          
            const imageCount = targetNode.getElementsByTagName('img').length;

            if (scrollbarWrapper) {
              if (imageCount === 1) {
            
                scrollbarWrapper.style.display = 'none';
              } else {
            
                scrollbarWrapper.style.display = ''; 
              }
            }
          }
        }
      };
  
  
      const config = { childList: true, subtree: true };
  
    
      const observer = new MutationObserver(callback);
  
 
      if (targetNode && scrollbarWrapper) {
    
        const initialImageCount = targetNode.getElementsByTagName('img').length;
        if (initialImageCount === 1) {
          scrollbarWrapper.style.display = 'none';
        }
  
        observer.observe(targetNode, config);
       
      }
  
    }
  
  });